import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Tracking from './Tracking';
import TrackingContext from './TrackingContext';
var propTypes = {
  tracking: PropTypes.instanceOf(Tracking),
  children: PropTypes.node
};
var defaultProps = {
  tracking: null,
  children: null
};

var TrackingContainer = function TrackingContainer(_ref) {
  var children = _ref.children,
      tracking = _ref.tracking;
  var finalTracking = useMemo(function () {
    return tracking || new Tracking();
  }, [tracking]);
  return React.createElement(TrackingContext.Provider, {
    value: finalTracking
  }, children);
};

TrackingContainer.propTypes = propTypes;
TrackingContainer.defaultProps = defaultProps;
export default TrackingContainer;